import React from 'react';
import './Header.less';

class Header extends React.Component {

	render() {
		const { value } = this.props;
		return (
			<div className="header">
				<div className="header__logo">
					<img src={process.env.REACT_APP_LOGO} alt={process.env.REACT_APP_COMPANY} />
				</div>
				<div className="header__text">
					<div className="header__title">{process.env.REACT_APP_TITLE}</div>
					<div className="header__sub-title">{process.env.REACT_APP_SUBTITLE}</div>
				</div>
				<div className="header__client-logo">
					<img src={value.logo} alt="Logo" />
				</div>
			</div>
		);
	}
}

export default Header;
